import styled, { css } from 'styled-components';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Wrapper = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: 1fr 521px;
  grid-gap: 25px;
  padding: 30px;
`;

export const Holder = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-rows: 1fr;
  grid-gap: 30px;

  ${(props) =>
    props.isBox &&
    css`
      /* align-items: flex-start; */
      overflow: auto;

      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: ${(props) => props.theme.thumb};
      }

      &::-webkit-scrollbar-track {
        background: ${(props) => props.theme.track};
      }
    `}
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  padding: 25px;
`;

export const ContentHolder = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  padding: 4px 0 12px;
  border-bottom: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
`;

export const Title = styled.h2`
  display: inline-flex;
  align-items: center;
  color: ${(props) => props.theme.color};
  font-size: 20px;
  font-weight: 700;
  text-align: left;
  cursor: default;
`;

export const Content = styled.div`
  display: block;
  width: 100%;
  padding: 15px 0;
`;

export const Button = styled.button`
  ${commonButton}
  min-width: 137px;
`;

export const ActionButton = styled.button`
  ${commonButton}
  margin-left: 15px;
`;

export const ActionButtonIcon = styled.i``;

export const Category = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 25px;
`;

export const CategoryTitle = styled.h3`
  display: block;
  width: 100%;
  margin-bottom: 15px;
  color: ${(props) => props.theme.color};
  font-size: 18px;
  font-weight: 500;
  cursor: default;
`;

export const CategoryValues = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 8px;
`;

export const CategoryValue = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  border-radius: 10px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  word-break: break-word;
  cursor: pointer;

  ${(props) =>
    props.selected &&
    css`
      color: ${(props) => props.theme.colorOnSelected};
      background: ${(props) => props.theme.backgroundOnSelected};
    `}
`;

export const Selectbox = styled.div`
  display: block;
  width: 100%;
  padding-right: 25px;
`;

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
  grid-template-rows: 1fr 1fr;
  grid-gap: 15px;
  padding: 5px;
`;
